// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge-light {
  color: #212529 !important;
  background-color: #f8f9fa;
}

.diamond-cert,
.product-reference {
  position: relative;
}

.sales-title {
  position: relative;
  display: inline-block;
  align-self: center;
  margin: 0;
}

body {
  height: 100vh;
  overflow: hidden;
}

.check-all-link {
  cursor: pointer;
}

.link_to_dashboard {
  display: inline-block;
  float: left;
}
.link_to_dashboard a {
  display: inline-block;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: 5px;
}

.ml-0 {
  margin-left: 0px !important;
}

.db-top-heading {
  position: relative;
  justify-content: center;
  background: #000000;
  color: white;
  padding: 7px 10px 7px 0px;
  display: flex;
  margin-bottom: 0px;
  width: calc(100% - 60px);
  margin-top: 0px;
  border-radius: 0px;
  height: 50px;
}

#SaleEditDiamondSearch_component tr.highlighted_row,
#SaleEditProductReferenceSearch_component tr.highlighted_row {
  background-color: #e3b5bb;
  color: #fff;
}
#SaleEditDiamondSearch_component tr.highlighted_row td,
#SaleEditProductReferenceSearch_component tr.highlighted_row td {
  color: #fff;
}

#LoadInvoices_component .table-container {
  height: calc(100vh - 100px);
  overflow-y: auto !important;
  overflow: auto;
}
#LoadInvoices_component .load_invoices_list {
  overflow-y: auto !important;
}
#LoadInvoices_component .load_invoices_list::-webkit-scrollbar {
  display: none;
}
#LoadInvoices_component .formatLink {
  font-size: 18px;
  color: green;
  text-decoration: none;
}
#LoadInvoices_component tr.highlighted_row {
  background-color: #e3b5bb;
  color: #fff;
}
#LoadInvoices_component tr.highlighted_row td {
  color: #fff;
}
#LoadInvoices_component .strong {
  font-weight: bold;
}
#LoadInvoices_component .container_sales {
  padding: 15px;
}
#LoadInvoices_component .container_sales .list_and_information {
  font-size: 13px;
}
#LoadInvoices_component .container_sales .list_and_information .header {
  width: 100%;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .sheetType_selection {
  margin-left: 0px;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .sheetType_selection .update-btn {
  background-color: black;
  color: white;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #LoadInvoices_component .container_sales .list_and_information .header .header_tools .sheetType_selection {
    margin-left: 0;
  }
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .total_items {
  display: inline-block;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .total_items .box-label {
  display: block;
  margin-bottom: 5px;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .total_items .box-bg {
  display: block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .general_searcj {
  display: inline-block;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .general_searcj .box-label {
  display: block;
  margin-bottom: 5px;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .general_searcj .box-bg {
  display: block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  box-shadow: none;
  border-color: transparent;
  max-height: 31px;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .filter_by {
  margin-left: 0px;
  display: inline-block;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .sheetType_selection .box-label,
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .filter_by .box-label {
  display: block;
  margin-bottom: 5px;
}
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .sheetType_selection .select-box,
#LoadInvoices_component .container_sales .list_and_information .header .header_tools .filter_by .select-box {
  display: block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
}
#LoadInvoices_component .float-right {
  float: right;
}
#LoadInvoices_component .list_and_information .sales_list {
  width: 100%;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #LoadInvoices_component .list_and_information .sales_list {
    width: 100%;
  }
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #LoadInvoices_component .list_and_information .sales_list .col-left,
  #LoadInvoices_component .list_and_information .sales_list .col-right {
    width: 100%;
  }
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #LoadInvoices_component .list_and_information .sales_list .col-right {
    margin-top: 20px;
  }
}
#LoadInvoices_component .list_and_information .sales_list table {
  font-size: 13px;
}
#LoadInvoices_component .list_and_information .sales_list table thead {
  position: sticky;
  top: 0;
}
#LoadInvoices_component .list_and_information .sales_list table thead tr.titles {
  border-style: hidden;
  background: #EEEEEE;
}
#LoadInvoices_component .list_and_information .sales_list table thead tr.titles th {
  position: sticky;
  top: 0;
  vertical-align: baseline;
}
@media only screen and (max-width: 1760px) {
  #LoadInvoices_component .list_and_information .sales_list table thead tr.titles th {
    font-size: 10px;
  }
}
@media only screen and (max-width: 1280px) {
  #LoadInvoices_component .list_and_information .sales_list table thead tr.titles th {
    font-size: 9px;
  }
}
#LoadInvoices_component .list_and_information .sales_list table thead tr.filters th input {
  width: 100%;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
}
#LoadInvoices_component .list_and_information .sales_list table thead tr.filters th.saleDate input {
  width: 100%;
}
#LoadInvoices_component .list_and_information .sales_list table tbody tr {
  cursor: pointer;
}
.text-right {
  text-align: right;
}

.border-none {
  border: none;
}

#SalesList_component .general_searcj,
#PostSalesList_component .general_searcj,
#PostSaleSearch_component .general_searcj,
#SaleDetail_component .general_searcj {
  display: inline-block;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SalesList_component .general_searcj,
  #PostSalesList_component .general_searcj,
  #PostSaleSearch_component .general_searcj,
  #SaleDetail_component .general_searcj {
    float: none;
    float: initial;
  }
}
#SalesList_component .general_searcj .box-label,
#PostSalesList_component .general_searcj .box-label,
#PostSaleSearch_component .general_searcj .box-label,
#SaleDetail_component .general_searcj .box-label {
  display: inline-block;
  margin-bottom: 5px;
}
#SalesList_component .general_searcj .box-bg,
#PostSalesList_component .general_searcj .box-bg,
#PostSaleSearch_component .general_searcj .box-bg,
#SaleDetail_component .general_searcj .box-bg {
  display: inline-block;
  background-color: transparent;
  padding: 5px 5px;
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #e3b5bb;
  max-height: 31px;
  margin-left: 10px;
  border-right: 0px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
#SalesList_component .general_searcj .box-bg:focus,
#PostSalesList_component .general_searcj .box-bg:focus,
#PostSaleSearch_component .general_searcj .box-bg:focus,
#SaleDetail_component .general_searcj .box-bg:focus {
  border-color: #e3b5bb !important;
}
#SalesList_component .general_searcj .input-group-append .input-group-text,
#PostSalesList_component .general_searcj .input-group-append .input-group-text,
#PostSaleSearch_component .general_searcj .input-group-append .input-group-text,
#SaleDetail_component .general_searcj .input-group-append .input-group-text {
  padding: 7px 5px;
  background: transparent;
  border: 1px solid #e3b5bb;
  border-left: 0px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
#SalesList_component .orderTypeCol,
#PostSalesList_component .orderTypeCol,
#PostSaleSearch_component .orderTypeCol,
#SaleDetail_component .orderTypeCol {
  color: white;
}
#SalesList_component .orderType,
#PostSalesList_component .orderType,
#PostSaleSearch_component .orderType,
#SaleDetail_component .orderType {
  color: #000000;
}
#SalesList_component .orderType.express,
#PostSalesList_component .orderType.express,
#PostSaleSearch_component .orderType.express,
#SaleDetail_component .orderType.express {
  color: #ffd500;
}
#SalesList_component .orderType.readyToShip,
#PostSalesList_component .orderType.readyToShip,
#PostSaleSearch_component .orderType.readyToShip,
#SaleDetail_component .orderType.readyToShip {
  color: #ff7700;
}
#SalesList_component .urgentDateRequestedByCustomer.highlighted,
#SalesList_component .dateCustomerNeedsBy.highlighted,
#PostSalesList_component .urgentDateRequestedByCustomer.highlighted,
#PostSalesList_component .dateCustomerNeedsBy.highlighted,
#PostSaleSearch_component .urgentDateRequestedByCustomer.highlighted,
#PostSaleSearch_component .dateCustomerNeedsBy.highlighted,
#SaleDetail_component .urgentDateRequestedByCustomer.highlighted,
#SaleDetail_component .dateCustomerNeedsBy.highlighted {
  color: #ff7700;
}
#SalesList_component .dateCustomerNeedsByHighlighted,
#PostSalesList_component .dateCustomerNeedsByHighlighted,
#PostSaleSearch_component .dateCustomerNeedsByHighlighted,
#SaleDetail_component .dateCustomerNeedsByHighlighted {
  color: #ff7700;
}
#SalesList_component .redText,
#PostSalesList_component .redText,
#PostSaleSearch_component .redText,
#SaleDetail_component .redText {
  color: red;
}
#SalesList_component .highlight,
#PostSalesList_component .highlight,
#PostSaleSearch_component .highlight,
#SaleDetail_component .highlight {
  color: red;
  font-weight: bold;
}

#SaleGeneralEdit_component .add_jeweller,
#SaleGeneralEdit_component .delete_jeweller {
  cursor: pointer;
}

.table_title {
  font-weight: bold;
}

.bold {
  font-weight: bold;
}

#SalesList_component .infinite-scroll-component,
#PostSalesList_component .infinite-scroll-component,
#PostSaleSearch_component .infinite-scroll-component {
  overflow-y: auto !important;
}
#SalesList_component .infinite-scroll-component::-webkit-scrollbar,
#PostSalesList_component .infinite-scroll-component::-webkit-scrollbar,
#PostSaleSearch_component .infinite-scroll-component::-webkit-scrollbar {
  display: none;
}
#SalesList_component table,
#PostSalesList_component table,
#PostSaleSearch_component table {
  /*table-layout: fixed;*/
  width: 100%;
}
#SalesList_component table th,
#PostSalesList_component table th,
#PostSaleSearch_component table th {
  vertical-align: top;
}
#SalesList_component table th .custom-from-check,
#PostSalesList_component table th .custom-from-check,
#PostSaleSearch_component table th .custom-from-check {
  min-height: auto;
  margin-bottom: 0;
}
#SalesList_component table tr.highlighted_row,
#PostSalesList_component table tr.highlighted_row,
#PostSaleSearch_component table tr.highlighted_row {
  background-color: #e3b5bb;
  color: #fff;
}
#SalesList_component table tr.highlighted_row td,
#PostSalesList_component table tr.highlighted_row td,
#PostSaleSearch_component table tr.highlighted_row td {
  color: #fff;
}
#SalesList_component table tr td,
#PostSalesList_component table tr td,
#PostSaleSearch_component table tr td {
  max-width: 120px;
  word-wrap: break-word;
}
#SalesList_component table tr td.addToMyList,
#PostSalesList_component table tr td.addToMyList,
#PostSaleSearch_component table tr td.addToMyList {
  width: 60px;
}
#SalesList_component table tr td.addToMyList .form-check-label,
#PostSalesList_component table tr td.addToMyList .form-check-label,
#PostSaleSearch_component table tr td.addToMyList .form-check-label {
  white-space: nowrap;
}
#SalesList_component input[type=checkbox],
#PostSalesList_component input[type=checkbox],
#PostSaleSearch_component input[type=checkbox] {
  width: 1em !important;
}
#SalesList_component .strong,
#PostSalesList_component .strong,
#PostSaleSearch_component .strong {
  font-weight: bold;
}
#SalesList_component .container_sales,
#PostSalesList_component .container_sales,
#PostSaleSearch_component .container_sales {
  padding: 0px 5px;
}
#SalesList_component .container_sales .list_and_information,
#PostSalesList_component .container_sales .list_and_information,
#PostSaleSearch_component .container_sales .list_and_information {
  font-size: 13px;
}
#SalesList_component .container_sales .list_and_information .header,
#PostSalesList_component .container_sales .list_and_information .header,
#PostSaleSearch_component .container_sales .list_and_information .header {
  width: 100%;
  margin-bottom: 10px;
}
#SalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .sheetType_selection {
  margin-left: 50px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
  #PostSalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
  #PostSaleSearch_component .container_sales .list_and_information .header .header_tools .sheetType_selection {
    margin-left: 0;
  }
}
#SalesList_component .container_sales .list_and_information .header .header_tools .total_items,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .total_items,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .total_items {
  display: inline-block;
}
#SalesList_component .container_sales .list_and_information .header .header_tools .total_items .box-label,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .total_items .box-label,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .total_items .box-label {
  display: block;
  margin-bottom: 5px;
}
#SalesList_component .container_sales .list_and_information .header .header_tools .total_items .box-bg,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .total_items .box-bg,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .total_items .box-bg {
  display: block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
}
#SalesList_component .container_sales .list_and_information .header .header_tools .generate_excel .btn,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .generate_excel .btn,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .generate_excel .btn {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 15px;
  border: 1px solid #8BA6EB;
  background: #8BA6EB;
  margin-left: 15px;
  text-align: center;
  color: white;
  padding: 0px;
}
#SalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
#SalesList_component .container_sales .list_and_information .header .header_tools .filter_by,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .filter_by,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .filter_by {
  margin-left: 0px;
  display: inline-block;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
  #SalesList_component .container_sales .list_and_information .header .header_tools .filter_by,
  #PostSalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
  #PostSalesList_component .container_sales .list_and_information .header .header_tools .filter_by,
  #PostSaleSearch_component .container_sales .list_and_information .header .header_tools .sheetType_selection,
  #PostSaleSearch_component .container_sales .list_and_information .header .header_tools .filter_by {
    margin-left: 0;
  }
}
#SalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection .box-label,
#SalesList_component .container_sales .list_and_information .header .header_tools .filter_by .box-label,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection .box-label,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .filter_by .box-label,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .sheetType_selection .box-label,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .filter_by .box-label {
  display: inline-block;
  margin-bottom: 5px;
}
#SalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection .select-box,
#SalesList_component .container_sales .list_and_information .header .header_tools .filter_by .select-box,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .sheetType_selection .select-box,
#PostSalesList_component .container_sales .list_and_information .header .header_tools .filter_by .select-box,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .sheetType_selection .select-box,
#PostSaleSearch_component .container_sales .list_and_information .header .header_tools .filter_by .select-box {
  display: inline-block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
  margin-left: 10px;
}
#SalesList_component .container_sales .list_and_information .row-sales-controls,
#PostSalesList_component .container_sales .list_and_information .row-sales-controls,
#PostSaleSearch_component .container_sales .list_and_information .row-sales-controls {
  justify-content: space-between;
  width: 100%;
  display: flex !important;
  flex-direction: row;
  float: none !important;
}
#SalesList_component .container_sales .list_and_information .customised-sales-controls,
#PostSalesList_component .container_sales .list_and_information .customised-sales-controls,
#PostSaleSearch_component .container_sales .list_and_information .customised-sales-controls {
  display: flex;
}
#SalesList_component .container_sales .list_and_information .add-new-tab,
#PostSalesList_component .container_sales .list_and_information .add-new-tab,
#PostSaleSearch_component .container_sales .list_and_information .add-new-tab {
  width: auto;
  width: initial;
}
#SalesList_component .container_sales .list_and_information .add_new_sale,
#PostSalesList_component .container_sales .list_and_information .add_new_sale,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale {
  display: inline-block;
  float: right;
  margin-left: 0px;
}
#SalesList_component .container_sales .list_and_information .add_new_sale button,
#PostSalesList_component .container_sales .list_and_information .add_new_sale button,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale button {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 15px;
  border: 1px solid #E3B5BB;
  background: #E3B5BB;
  margin-left: 15px;
  text-align: center;
  color: white;
  padding: 0px;
  display: inline-block;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div {
  display: inline-block;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter {
  display: inline-block;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .sheetType_selection,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .sheetType_selection,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .sheetType_selection {
  display: inline-block;
  margin-right: 10px;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .sheetType_selection .select-box,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .sheetType_selection .select-box,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .sheetType_selection .select-box {
  display: inline-block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
  margin-left: 10px;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj {
  display: inline-block;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj,
  #PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj,
  #PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj {
    float: none;
    float: initial;
  }
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-label,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-label,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-label {
  display: inline-block;
  margin-bottom: 5px;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-bg,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-bg,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-bg {
  display: inline-block;
  background-color: transparent;
  padding: 5px 5px;
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #e3b5bb;
  max-height: 31px;
  margin-left: 10px;
  border-right: 0px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-bg:focus,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-bg:focus,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .box-bg:focus {
  border-color: #e3b5bb !important;
}
#SalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .input-group-append .input-group-text,
#PostSalesList_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .input-group-append .input-group-text,
#PostSaleSearch_component .container_sales .list_and_information .add_new_sale .fixed-height-div .search-filter .general_searcj .input-group-append .input-group-text {
  padding: 7px 5px;
  background: transparent;
  border: 1px solid #e3b5bb;
  border-left: 0px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
#SalesList_component .float-right,
#PostSalesList_component .float-right,
#PostSaleSearch_component .float-right {
  float: right;
}
#SalesList_component .list_and_information .sales_list,
#PostSalesList_component .list_and_information .sales_list,
#PostSaleSearch_component .list_and_information .sales_list {
  width: 70%;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SalesList_component .list_and_information .sales_list,
  #PostSalesList_component .list_and_information .sales_list,
  #PostSaleSearch_component .list_and_information .sales_list {
    width: 100%;
  }
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SalesList_component .list_and_information .sales_list .col-left,
  #SalesList_component .list_and_information .sales_list .col-right,
  #PostSalesList_component .list_and_information .sales_list .col-left,
  #PostSalesList_component .list_and_information .sales_list .col-right,
  #PostSaleSearch_component .list_and_information .sales_list .col-left,
  #PostSaleSearch_component .list_and_information .sales_list .col-right {
    width: 100%;
  }
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SalesList_component .list_and_information .sales_list .col-right,
  #PostSalesList_component .list_and_information .sales_list .col-right,
  #PostSaleSearch_component .list_and_information .sales_list .col-right {
    margin-top: 20px;
  }
}
#SalesList_component .list_and_information .sales_list .tab-pane,
#PostSalesList_component .list_and_information .sales_list .tab-pane,
#PostSaleSearch_component .list_and_information .sales_list .tab-pane {
  overflow: auto;
  width: 100%;
}
#SalesList_component .list_and_information .sales_list .tab-pane::-webkit-scrollbar,
#PostSalesList_component .list_and_information .sales_list .tab-pane::-webkit-scrollbar,
#PostSaleSearch_component .list_and_information .sales_list .tab-pane::-webkit-scrollbar {
  display: none;
}
#SalesList_component .list_and_information .sales_list table,
#PostSalesList_component .list_and_information .sales_list table,
#PostSaleSearch_component .list_and_information .sales_list table {
  font-size: 13px;
}
#SalesList_component .list_and_information .sales_list table thead,
#PostSalesList_component .list_and_information .sales_list table thead,
#PostSaleSearch_component .list_and_information .sales_list table thead {
  background-color: white;
  position: sticky;
  top: 0;
}
#SalesList_component .list_and_information .sales_list table thead tr.titles,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles {
  border-style: hidden;
  background: #000000;
  color: white;
}
#SalesList_component .list_and_information .sales_list table thead tr.titles th,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles th,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles th {
  position: sticky;
  top: 0;
  vertical-align: baseline;
}
@media only screen and (max-width: 1760px) {
  #SalesList_component .list_and_information .sales_list table thead tr.titles th,
  #PostSalesList_component .list_and_information .sales_list table thead tr.titles th,
  #PostSaleSearch_component .list_and_information .sales_list table thead tr.titles th {
    font-size: 10px;
  }
}
@media only screen and (max-width: 1280px) {
  #SalesList_component .list_and_information .sales_list table thead tr.titles th,
  #PostSalesList_component .list_and_information .sales_list table thead tr.titles th,
  #PostSaleSearch_component .list_and_information .sales_list table thead tr.titles th {
    font-size: 9px;
  }
}
#SalesList_component .list_and_information .sales_list table thead tr.titles .saleDate,
#SalesList_component .list_and_information .sales_list table thead tr.titles .dateCustomerNeedsBy,
#SalesList_component .list_and_information .sales_list table thead tr.titles .created,
#SalesList_component .list_and_information .sales_list table thead tr.titles .dateReceivedInBackOffice,
#SalesList_component .list_and_information .sales_list table thead tr.titles .dueDate,
#SalesList_component .list_and_information .sales_list table thead tr.titles .addToMyList,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles .saleDate,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles .dateCustomerNeedsBy,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles .created,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles .dateReceivedInBackOffice,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles .dueDate,
#PostSalesList_component .list_and_information .sales_list table thead tr.titles .addToMyList,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles .saleDate,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles .dateCustomerNeedsBy,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles .created,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles .dateReceivedInBackOffice,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles .dueDate,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.titles .addToMyList {
  cursor: pointer;
}
#SalesList_component .list_and_information .sales_list table thead tr.filters th,
#PostSalesList_component .list_and_information .sales_list table thead tr.filters th,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.filters th {
  gap: 10px;
}
#SalesList_component .list_and_information .sales_list table thead tr.filters th input,
#PostSalesList_component .list_and_information .sales_list table thead tr.filters th input,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.filters th input {
  width: 100%;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
}
#SalesList_component .list_and_information .sales_list table thead tr.filters th.saleDate input,
#PostSalesList_component .list_and_information .sales_list table thead tr.filters th.saleDate input,
#PostSaleSearch_component .list_and_information .sales_list table thead tr.filters th.saleDate input {
  width: 95px;
}
#SalesList_component .list_and_information .sales_list table tbody tr,
#PostSalesList_component .list_and_information .sales_list table tbody tr,
#PostSaleSearch_component .list_and_information .sales_list table tbody tr {
  cursor: pointer;
}
#SalesList_component .nav-tabs .nav-link,
#SalesList_component .nav-item.show .nav-link,
#PostSalesList_component .nav-tabs .nav-link,
#PostSalesList_component .nav-item.show .nav-link,
#PostSaleSearch_component .nav-tabs .nav-link,
#PostSaleSearch_component .nav-item.show .nav-link {
  color: #E3B5BB !important;
  border-color: #E3B5BB !important;
}
#SalesList_component .nav-tabs .nav-link.active,
#SalesList_component .nav-item.show .nav-link.active,
#PostSalesList_component .nav-tabs .nav-link.active,
#PostSalesList_component .nav-item.show .nav-link.active,
#PostSaleSearch_component .nav-tabs .nav-link.active,
#PostSaleSearch_component .nav-item.show .nav-link.active {
  background-color: #E3B5BB !important;
  color: white !important;
}

.modal.sale-edit-close-confirmation {
  z-index: 2000;
}
.modal.sale-edit-close-confirmation .modal-dialog {
  margin-top: 100px;
  max-width: 50%;
  width: 50%;
}
.modal .nav-tabs .nav-link,
.modal .nav-item.show .nav-link {
  color: #8ba6eb !important;
}
.modal .nav-tabs .nav-link.active,
.modal .nav-item.show .nav-link.active {
  background-color: black !important;
  color: white !important;
  border-color: black !important;
}
.modal .nav-tabs .nav-link.pending-changes,
.modal .nav-item.show .nav-link.pending-changes {
  color: red !important;
}
.modal form .form-group {
  margin-bottom: 1rem;
}
.modal form .select-box {
  display: inline-block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
  margin-left: 10px;
}
.modal form .react-datepicker-wrapper .react-datepicker__input-container input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  width: 100%;
}
.modal form button[type=submit] {
  background-color: black;
  border-color: black;
}

#PostSaleSearch_component .infinite-scroll-component {
  margin-bottom: 20px;
}
#PostSaleSearch_component .addToMyList {
  display: none;
}

.center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-novita-pink {
  background-color: #E3B5BB !important;
  color: white !important;
  border-color: #E3B5BB !important;
}

.btn-novita-pink-outline {
  color: #E3B5BB !important;
  border-color: #E3B5BB !important;
}
.btn-novita-pink-outline:hover {
  background-color: #E3B5BB !important;
  color: white !important;
}

.cost-not-ready {
  background: #fcdddb;
  padding-bottom: 15px;
}

.cost-not-ready-color {
  color: red;
}

.workflow-cost-summary-container {
  padding: 0 0px;
  border-left: 1px solid gray;
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.workflow-cost-summary-container .workflow-cost-activities {
  padding: 0 5px;
}
.workflow-cost-summary-container .workflow-cost-activities .workflow-cost-activity {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  overflow: hidden;
  margin-bottom: 15px;
}
.workflow-cost-summary-container .workflow-cost-activities h2.workflow-acivity-melees {
  background-color: transparent !important;
  border-bottom: 1px solid gray;
  color: #000 !important;
}
.workflow-cost-summary-container .workflow-cost-activities h2.workflow-acivity-metal {
  background-color: transparent !important;
  border-bottom: 1px solid gray;
  color: #000 !important;
}

#table_my_list {
  height: 100%;
}

#SaleWorkflowEditCAD_request_component .btn-round {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 15px;
  border: 1px solid #E3B5BB;
  background: #E3B5BB;
  text-align: center;
  color: white;
  padding: 0px;
  display: inline-block;
}
#SaleWorkflowEditCAD_request_component #cad_files_list_table td {
  vertical-align: middle;
}
#SaleWorkflowEditCAD_request_component #cad_files_list_table img {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
#SaleWorkflowEditCAD_request_component .rbt-input-multi.form-control {
  min-height: 64px;
}

#SaleWorkflowEditCADList_component .workflowCadRequestTableList {
  max-height: calc(-100px + 100vh);
  overflow: auto;
}
#SaleWorkflowEditCADList_component table {
  font-size: 13px;
}
#SaleWorkflowEditCADList_component table thead {
  background-color: white;
}
#SaleWorkflowEditCADList_component table thead tr.titles {
  border-style: hidden;
  background: #EEEEEE;
}
#SaleWorkflowEditCADList_component table thead tr.titles th.action {
  top: 0;
  vertical-align: baseline;
  background-color: inherit;
  max-width: 20%;
  width: 20%;
  text-align: left;
}
#SaleWorkflowEditCADList_component table tbody tr td.action {
  max-width: 20%;
  width: 20%;
  text-align: left;
  padding: 10px;
  vertical-align: middle;
}
#SaleWorkflowEditCADList_component table tbody tr td.action span {
  margin-bottom: 3px;
  display: block;
  color: #5673f8;
}
#SaleWorkflowEditCADList_component table tbody tr td.action span.mr-5 {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/sales/sales.scss"],"names":[],"mappings":"AASA;EACI,yBAAA;EACA,yBAAA;AARJ;;AAWA;;EAEI,kBAAA;AARJ;;AAWA;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;EACI,eAAA;AARJ;;AAWA;EACI,qBAAA;EACA,WAAA;AARJ;AAUI;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AARR;;AAYA;EACI,2BAAA;AATJ;;AAYA;EACI,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AATJ;;AAcI;;EACI,yBAAA;EACA,WAAA;AAVR;AAYQ;;EACI,WAAA;AATZ;;AAeI;EACI,2BAAA;EACA,2BAAA;EACA,cAAA;AAZR;AAeI;EACI,2BAAA;AAbR;AAgBQ;EACI,aAAA;AAdZ;AAkBI;EACI,eAAA;EACA,YAAA;EACA,qBAAA;AAhBR;AAmBI;EACI,yBAAA;EACA,WAAA;AAjBR;AAmBQ;EACI,WAAA;AAjBZ;AAqBI;EACI,iBAAA;AAnBR;AAyBI;EACI,aAAA;AAvBR;AAyBQ;EAEI,eArHQ;AA6FpB;AA0BY;EACI,WAAA;AAxBhB;AA6BoB;EACI,gBAAA;AA3BxB;AA6BwB;EACI,uBAAA;EACA,YAAA;AA3B5B;AA8BwB;EARJ;IASQ,cAAA;EA3B1B;AACF;AA8BoB;EACI,qBAAA;AA5BxB;AA8BwB;EACI,cAAA;EACA,kBAAA;AA5B5B;AA+BwB;EACI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AA7B5B;AAiCoB;EACI,qBAAA;AA/BxB;AAiCwB;EACI,cAAA;EACA,kBAAA;AA/B5B;AAkCwB;EACI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAhC5B;AAoCoB;;EAEI,gBAAA;EACA,qBAAA;AAlCxB;AAoCwB;;EACI,cAAA;EACA,kBAAA;AAjC5B;AAoCwB;;EACI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAjC5B;AAyCI;EACI,YAAA;AAvCR;AA8CQ;EACI,WAAA;AA5CZ;AA8CY;EAHJ;IAIQ,WAAA;EA3Cd;AACF;AA+CgB;EAFJ;;IAGQ,WAAA;EA3ClB;AACF;AA+CgB;EADJ;IAEQ,gBAAA;EA5ClB;AACF;AA+CY;EACI,eAlOI;AAqLpB;AA+CgB;EACI,gBAAA;EACA,MAAA;AA7CpB;AA+CoB;EACI,oBAAA;EACA,mBAAA;AA7CxB;AA+CwB;EACI,gBAAA;EACA,MAAA;EACA,wBAAA;AA7C5B;AA+C4B;EALJ;IAMQ,eAAA;EA5C9B;AACF;AA8C4B;EATJ;IAUQ,cAAA;EA3C9B;AACF;AAiD4B;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;AA/ChC;AAmDgC;EACI,WAAA;AAjDpC;AAyDoB;EACI,eAAA;AAvDxB;AAiEA;EACI,iBAAA;AA/DJ;;AAkEA;EACI,YAAA;AA/DJ;;AAsEI;;;;EACI,qBAAA;AAhER;AAkEQ;EAHJ;;;;IAIQ,WAAA;IAAA,cAAA;EA5DV;AACF;AA8DQ;;;;EACI,qBAAA;EACA,kBAAA;AAzDZ;AA4DQ;;;;EACI,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;AAvDZ;AAyDY;;;;EACI,gCAAA;AApDhB;AAyDY;;;;EACI,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AApDhB;AAyDI;;;;EACI,YAAA;AApDR;AAuDI;;;;EACI,cAAA;AAlDR;AAoDQ;;;;EACI,cAAA;AA/CZ;AAkDQ;;;;EACI,cAAA;AA7CZ;AAmDQ;;;;;;;;EACI,cAAA;AA1CZ;AA8CI;;;;EACI,cAAA;AAzCR;AA4CI;;;;EACI,UAAA;AAvCR;AA0CI;;;;EACI,UAAA;EACA,iBAAA;AArCR;;AA2CI;;EAEI,eAAA;AAxCR;;AA4CA;EACI,iBAAA;AAzCJ;;AA4CA;EACI,iBAAA;AAzCJ;;AA+CI;;;EACI,2BAAA;AA1CR;AA6CQ;;;EACI,aAAA;AAzCZ;AA6CI;;;EACI,uBAAA;EACA,WAAA;AAzCR;AA2CQ;;;EACI,mBAAA;AAvCZ;AAyCY;;;EACI,gBAAA;EACA,gBAAA;AArChB;AA4CY;;;EACI,yBAAA;EACA,WAAA;AAxChB;AA0CgB;;;EACI,WAAA;AAtCpB;AA0CY;;;EACI,gBAAA;EACA,qBAAA;AAtChB;AAwCgB;;;EACI,WAAA;AApCpB;AAsCoB;;;EACI,mBAAA;AAlCxB;AAyCI;;;EACI,qBAAA;AArCR;AAwCI;;;EACI,iBAAA;AApCR;AA0CI;;;EACI,gBAAA;AAtCR;AAwCQ;;;EAEI,eAzcQ;AAoapB;AAuCY;;;EACI,WAAA;EACA,mBAAA;AAnChB;AAwCoB;;;EACI,iBAAA;AApCxB;AAsCwB;EAHJ;;;IAIQ,cAAA;EAjC1B;AACF;AAoCoB;;;EACI,qBAAA;AAhCxB;AAkCwB;;;EACI,cAAA;EACA,kBAAA;AA9B5B;AAiCwB;;;EACI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AA7B5B;AAkCwB;;;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AA9B5B;AAkCoB;;;;;;EAEI,gBAAA;EACA,qBAAA;AA5BxB;AA8BwB;EALJ;;;;;;IAMQ,cAAA;EAtB1B;AACF;AAwBwB;;;;;;EACI,qBAAA;EACA,kBAAA;AAjB5B;AAoBwB;;;;;;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAb5B;AAmBY;;;EACI,8BAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;AAfhB;AAkBY;;;EACI,aAAA;AAdhB;AAiBY;;;EACI,WAAA;EAAA,cAAA;AAbhB;AAgBY;;;EACI,qBAAA;EACA,YAAA;EACA,gBAAA;AAZhB;AAcgB;;;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AAVpB;AAagB;;;EACI,qBAAA;AATpB;AAWoB;;;EACI,qBAAA;AAPxB;AASwB;;;EACI,qBAAA;EACA,kBAAA;AAL5B;AAO4B;;;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAHhC;AAOwB;;;EACI,qBAAA;AAH5B;AAK4B;EAHJ;;;IAIQ,WAAA;IAAA,cAAA;EAA9B;AACF;AAE4B;;;EACI,qBAAA;EACA,kBAAA;AAEhC;AAC4B;;;EACI,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;AAGhC;AADgC;;;EACI,gCAAA;AAKpC;AAAgC;;;EACI,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AAIpC;AAMI;;;EACI,YAAA;AAFR;AASQ;;;EACI,UAAA;AALZ;AAOY;EAHJ;;;IAIQ,WAAA;EAFd;AACF;AAMgB;EAFJ;;;;;;IAGQ,WAAA;EAElB;AACF;AAEgB;EADJ;;;IAEQ,gBAAA;EAGlB;AACF;AAAY;;;EACI,cAAA;EACA,WAAA;AAIhB;AADgB;;;EACI,aAAA;AAKpB;AADY;;;EACI,eArqBI;AA0qBpB;AAHgB;;;EACI,uBAAA;EACA,gBAAA;EACA,MAAA;AAOpB;AALoB;;;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;AASxB;AAPwB;;;EACI,gBAAA;EACA,MAAA;EACA,wBAAA;AAW5B;AAT4B;EALJ;;;IAMQ,eAAA;EAc9B;AACF;AAZ4B;EATJ;;;IAUQ,cAAA;EAiB9B;AACF;AAdwB;;;;;;;;;;;;;;;;;;EAMI,eAAA;AA4B5B;AAvBwB;;;EACI,SAAA;AA2B5B;AAzB4B;;;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;AA6BhC;AAzBgC;;;EACI,WAAA;AA6BpC;AArBoB;;;EACI,eAAA;AAyBxB;AAdQ;;;;;;EACI,yBAAA;EACA,gCAAA;AAqBZ;AAnBY;;;;;;EACI,oCAAA;EACA,uBAAA;AA0BhB;;AAnBI;EACI,aAAA;AAsBR;AApBQ;EACI,iBAAA;EACA,cAAA;EACA,UAAA;AAsBZ;AAhBQ;;EACI,yBAAA;AAmBZ;AAjBY;;EACI,kCAAA;EACA,uBAAA;EACA,8BAAA;AAoBhB;AAjBY;;EACI,qBAAA;AAoBhB;AAdQ;EACI,mBAAA;AAgBZ;AAbQ;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAeZ;AAVgB;EACI,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;AAYpB;AAPQ;EACI,uBAAA;EACA,mBAAA;AASZ;;AAHI;EAEI,mBAAA;AAKR;AAFI;EACI,aAAA;AAIR;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAGJ;;AAAA;EACI,oCAAA;EACA,uBAAA;EACA,gCAAA;AAGJ;;AAAA;EACI,yBAAA;EACA,gCAAA;AAGJ;AADI;EACI,oCAAA;EACA,uBAAA;AAGR;;AACA;EACI,mBAAA;EACA,oBAAA;AAEJ;;AACA;EACI,UAAA;AAEJ;;AACA;EACI,cAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;AAEJ;AADI;EACI,cAAA;AAGR;AAFQ;EACI,4BAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;AAIZ;AAFQ;EACI,wCAAA;EACA,6BAAA;EACA,sBAAA;AAIZ;AAFQ;EACI,wCAAA;EACA,6BAAA;EACA,sBAAA;AAIZ;;AACA;EACI,YAAA;AAEJ;;AACI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AAER;AAEQ;EACI,sBAAA;AAAZ;AAEQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAAZ;AAGI;EACI,gBAAA;AADR;;AAMI;EACI,gCAAA;EACA,cAAA;AAHR;AAKI;EACI,eAl6BY;AA+5BpB;AAKQ;EACI,uBAAA;AAHZ;AAIY;EACI,oBAAA;EACA,mBAAA;AAFhB;AAIgB;EACI,MAAA;EACA,wBAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAFpB;AASgB;EACI,cAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAPpB;AASoB;EACI,kBAAA;EACA,cAAA;EACA,cAl8BZ;AA27BZ;AAQwB;EACI,kBAAA;AAN5B","sourcesContent":["$color_red_1: #FF9AA2;\n$color_red_2: #FFB7B2;\n$color_orange: #FFDAC1;\n$color_grass: #E2F0CB;\n$color_green: #B5EAD7;\n$color_purlple: #C7CEEA;\n$blue_link: #5673f8;\n$font_size_content: 13px;\n\n.badge-light {\n    color: #212529 !important;\n    background-color: #f8f9fa;\n}\n\n.diamond-cert,\n.product-reference {\n    position: relative;\n}\n\n.sales-title {\n    position: relative;\n    display: inline-block;\n    align-self: center;\n    margin: 0;\n}\n\nbody {\n    height: 100vh;\n    overflow: hidden;\n}\n\n.check-all-link {\n    cursor: pointer;\n}\n\n.link_to_dashboard {\n    display: inline-block;\n    float: left;\n\n    a {\n        display: inline-block;\n        color: #fff;\n        text-align: center;\n        font-size: 12px;\n        line-height: 15px;\n        text-transform: uppercase;\n        text-decoration: none;\n        border-radius: 5px;\n    }\n}\n\n.ml-0 {\n    margin-left: 0px !important;\n}\n\n.db-top-heading {\n    position: relative;\n    justify-content: center;\n    background: #000000;\n    color: white;\n    padding: 7px 10px 7px 0px;\n    display: flex;\n    margin-bottom: 0px;\n    width: calc(100% - 60px);\n    margin-top: 0px;\n    border-radius: 0px;\n    height: 50px;\n}\n\n#SaleEditDiamondSearch_component,\n#SaleEditProductReferenceSearch_component {\n    tr.highlighted_row {\n        background-color: #e3b5bb;\n        color: #fff;\n\n        td {\n            color: #fff;\n        }\n    }\n}\n\n#LoadInvoices_component {\n    .table-container {\n        height: calc(100vh - 100px);\n        overflow-y: auto !important;\n        overflow: auto;\n    }\n\n    .load_invoices_list {\n        overflow-y: auto !important;\n\n        // height: calc(100vh - 200px) !important;\n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n\n    .formatLink {\n        font-size: 18px;\n        color: green;\n        text-decoration: none;\n    }\n\n    tr.highlighted_row {\n        background-color: #e3b5bb;\n        color: #fff;\n\n        td {\n            color: #fff;\n        }\n    }\n\n    .strong {\n        font-weight: bold;\n    }\n\n    // ------------------------\n    //GENERAL DESIGN\n    // ------------------------\n    .container_sales {\n        padding: 15px;\n\n        .list_and_information {\n            // display: flex;\n            font-size: $font_size_content;\n\n            .header {\n                width: 100%;\n\n                .header_tools {\n\n                    // display: flex;\n                    .sheetType_selection {\n                        margin-left: 0px;\n\n                        .update-btn {\n                            background-color: black;\n                            color: white;\n                        }\n\n                        @media all and (min-width: 0px) and (max-width: 600px) {\n                            margin-left: 0;\n                        }\n                    }\n\n                    .total_items {\n                        display: inline-block;\n\n                        .box-label {\n                            display: block;\n                            margin-bottom: 5px;\n                        }\n\n                        .box-bg {\n                            display: block;\n                            background-color: #F4F4F4;\n                            padding: 5px 5px;\n                            border-radius: 5px;\n                            border-color: #F4F4F4;\n                        }\n                    }\n\n                    .general_searcj {\n                        display: inline-block;\n\n                        .box-label {\n                            display: block;\n                            margin-bottom: 5px;\n                        }\n\n                        .box-bg {\n                            display: block;\n                            background-color: #F4F4F4;\n                            padding: 5px 5px;\n                            border-radius: 5px;\n                            box-shadow: none;\n                            border-color: transparent;\n                            max-height: 31px;\n                        }\n                    }\n\n                    .sheetType_selection,\n                    .filter_by {\n                        margin-left: 0px;\n                        display: inline-block;\n\n                        .box-label {\n                            display: block;\n                            margin-bottom: 5px;\n                        }\n\n                        .select-box {\n                            display: block;\n                            background-color: #F4F4F4;\n                            padding: 5px 5px;\n                            border-radius: 5px;\n                            border-color: #F4F4F4;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .float-right {\n        float: right;\n    }\n\n    // ------------------------\n    //LEFT PANEL\n    // ------------------------\n    .list_and_information {\n        .sales_list {\n            width: 100%;\n\n            @media all and (min-width: 0px) and (max-width: 600px) {\n                width: 100%;\n            }\n\n            .col-left,\n            .col-right {\n                @media all and (min-width: 0px) and (max-width: 600px) {\n                    width: 100%;\n                }\n            }\n\n            .col-right {\n                @media all and (min-width: 0px) and (max-width: 600px) {\n                    margin-top: 20px;\n                }\n            }\n\n            table {\n                font-size: $font_size_content;\n\n                thead {\n                    position: sticky;\n                    top: 0;\n\n                    tr.titles {\n                        border-style: hidden;\n                        background: #EEEEEE;\n\n                        th {\n                            position: sticky;\n                            top: 0;\n                            vertical-align: baseline;\n\n                            @media only screen and (max-width: 1760px) {\n                                font-size: 10px;\n                            }\n\n                            @media only screen and (max-width: 1280px) {\n                                font-size: 9px;\n                            }\n                        }\n                    }\n\n                    tr.filters {\n                        th {\n                            input {\n                                width: 100%;\n                                border: 1px solid #d2d2d2;\n                                border-radius: 3px;\n                            }\n\n                            &.saleDate {\n                                input {\n                                    width: 100%;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                tbody {\n                    tr {\n                        cursor: pointer;\n\n                        td {}\n                    }\n                }\n            }\n        }\n    }\n}\n\n.text-right {\n    text-align: right;\n}\n\n.border-none {\n    border: none;\n}\n\n#SalesList_component,\n#PostSalesList_component,\n#PostSaleSearch_component,\n#SaleDetail_component {\n    .general_searcj {\n        display: inline-block;\n\n        @media all and (min-width: 0px) and (max-width: 600px) {\n            float: unset;\n        }\n\n        .box-label {\n            display: inline-block;\n            margin-bottom: 5px;\n        }\n\n        .box-bg {\n            display: inline-block;\n            background-color: transparent;\n            padding: 5px 5px;\n            border-radius: 5px;\n            box-shadow: none;\n            border: 1px solid#e3b5bb;\n            max-height: 31px;\n            margin-left: 10px;\n            border-right: 0px;\n            border-top-left-radius: 5px;\n            border-bottom-left-radius: 5px;\n            border-top-right-radius: 0px;\n            border-bottom-right-radius: 0px;\n\n            &:focus {\n                border-color: #e3b5bb !important;\n            }\n        }\n\n        .input-group-append {\n            .input-group-text {\n                padding: 7px 5px;\n                background: transparent;\n                border: 1px solid#e3b5bb;\n                border-left: 0px;\n                border-top-left-radius: 0px;\n                border-bottom-left-radius: 0px;\n            }\n        }\n    }\n\n    .orderTypeCol {\n        color: white;\n    }\n\n    .orderType {\n        color: #000000;\n\n        &.express {\n            color: #ffd500;\n        }\n\n        &.readyToShip {\n            color: #ff7700;\n        }\n    }\n\n    .urgentDateRequestedByCustomer,\n    .dateCustomerNeedsBy {\n        &.highlighted {\n            color: #ff7700;\n        }\n    }\n\n    .dateCustomerNeedsByHighlighted {\n        color: #ff7700;\n    }\n\n    .redText {\n        color: red;\n    }\n\n    .highlight {\n        color: red;\n        font-weight: bold;\n    }\n}\n\n#SaleGeneralEdit_component {\n\n    .add_jeweller,\n    .delete_jeweller {\n        cursor: pointer;\n    }\n}\n\n.table_title {\n    font-weight: bold;\n}\n\n.bold {\n    font-weight: bold;\n}\n\n#SalesList_component,\n#PostSalesList_component,\n#PostSaleSearch_component {\n    .infinite-scroll-component {\n        overflow-y: auto !important;\n\n        // height: calc(100vh - 200px) !important;\n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n\n    table {\n        /*table-layout: fixed;*/\n        width: 100%;\n\n        th {\n            vertical-align: top;\n\n            .custom-from-check {\n                min-height: auto;\n                margin-bottom: 0;\n\n                .empty-text {}\n            }\n        }\n\n        tr {\n            &.highlighted_row {\n                background-color: #e3b5bb;\n                color: #fff;\n\n                td {\n                    color: #fff;\n                }\n            }\n\n            td {\n                max-width: 120px;\n                word-wrap: break-word;\n\n                &.addToMyList {\n                    width: 60px;\n\n                    .form-check-label {\n                        white-space: nowrap;\n                    }\n                }\n            }\n        }\n    }\n\n    input[type='checkbox'] {\n        width: 1em !important;\n    }\n\n    .strong {\n        font-weight: bold;\n    }\n\n    // ------------------------\n    //GENERAL DESIGN\n    // ------------------------\n    .container_sales {\n        padding: 0px 5px;\n\n        .list_and_information {\n            // display: flex;\n            font-size: $font_size_content;\n\n            .header {\n                width: 100%;\n                margin-bottom: 10px;\n\n                .header_tools {\n\n                    // display: flex;\n                    .sheetType_selection {\n                        margin-left: 50px;\n\n                        @media all and (min-width: 0px) and (max-width: 600px) {\n                            margin-left: 0;\n                        }\n                    }\n\n                    .total_items {\n                        display: inline-block;\n\n                        .box-label {\n                            display: block;\n                            margin-bottom: 5px;\n                        }\n\n                        .box-bg {\n                            display: block;\n                            background-color: #F4F4F4;\n                            padding: 5px 5px;\n                            border-radius: 5px;\n                            border-color: #F4F4F4;\n                        }\n                    }\n\n                    .generate_excel {\n                        .btn {\n                            height: 32px;\n                            width: 32px;\n                            border-radius: 50%;\n                            font-size: 16px;\n                            line-height: 15px;\n                            border: 1px solid #8BA6EB;\n                            background: #8BA6EB;\n                            margin-left: 15px;\n                            text-align: center;\n                            color: white;\n                            padding: 0px;\n                        }\n                    }\n\n                    .sheetType_selection,\n                    .filter_by {\n                        margin-left: 0px;\n                        display: inline-block;\n\n                        @media all and (min-width: 0px) and (max-width: 600px) {\n                            margin-left: 0;\n                        }\n\n                        .box-label {\n                            display: inline-block;\n                            margin-bottom: 5px;\n                        }\n\n                        .select-box {\n                            display: inline-block;\n                            background-color: #F4F4F4;\n                            padding: 5px 5px;\n                            border-radius: 5px;\n                            border-color: #F4F4F4;\n                            margin-left: 10px;\n                        }\n                    }\n                }\n            }\n\n            .row-sales-controls {\n                justify-content: space-between;\n                width: 100%;\n                display: flex !important;\n                flex-direction: row;\n                float: none !important;\n            }\n\n            .customised-sales-controls {\n                display: flex;\n            }\n\n            .add-new-tab {\n                width: unset;\n            }\n\n            .add_new_sale {\n                display: inline-block;\n                float: right;\n                margin-left: 0px;\n\n                button {\n                    height: 30px;\n                    width: 30px;\n                    border-radius: 50%;\n                    font-size: 16px;\n                    line-height: 15px;\n                    border: 1px solid #E3B5BB;\n                    background: #E3B5BB;\n                    margin-left: 15px;\n                    text-align: center;\n                    color: white;\n                    padding: 0px;\n                    display: inline-block;\n                }\n\n                .fixed-height-div {\n                    display: inline-block;\n\n                    .search-filter {\n                        display: inline-block;\n\n                        .sheetType_selection {\n                            display: inline-block;\n                            margin-right: 10px;\n\n                            .select-box {\n                                display: inline-block;\n                                background-color: #F4F4F4;\n                                padding: 5px 5px;\n                                border-radius: 5px;\n                                border-color: #F4F4F4;\n                                margin-left: 10px;\n                            }\n                        }\n\n                        .general_searcj {\n                            display: inline-block;\n\n                            @media all and (min-width: 0px) and (max-width: 600px) {\n                                float: unset;\n                            }\n\n                            .box-label {\n                                display: inline-block;\n                                margin-bottom: 5px;\n                            }\n\n                            .box-bg {\n                                display: inline-block;\n                                background-color: transparent;\n                                padding: 5px 5px;\n                                border-radius: 5px;\n                                box-shadow: none;\n                                border: 1px solid#e3b5bb;\n                                max-height: 31px;\n                                margin-left: 10px;\n                                border-right: 0px;\n                                border-top-left-radius: 5px;\n                                border-bottom-left-radius: 5px;\n                                border-top-right-radius: 0px;\n                                border-bottom-right-radius: 0px;\n\n                                &:focus {\n                                    border-color: #e3b5bb !important;\n                                }\n                            }\n\n                            .input-group-append {\n                                .input-group-text {\n                                    padding: 7px 5px;\n                                    background: transparent;\n                                    border: 1px solid#e3b5bb;\n                                    border-left: 0px;\n                                    border-top-left-radius: 0px;\n                                    border-bottom-left-radius: 0px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .float-right {\n        float: right;\n    }\n\n    // ------------------------\n    //LEFT PANEL\n    // ------------------------\n    .list_and_information {\n        .sales_list {\n            width: 70%;\n\n            @media all and (min-width: 0px) and (max-width: 600px) {\n                width: 100%;\n            }\n\n            .col-left,\n            .col-right {\n                @media all and (min-width: 0px) and (max-width: 600px) {\n                    width: 100%;\n                }\n            }\n\n            .col-right {\n                @media all and (min-width: 0px) and (max-width: 600px) {\n                    margin-top: 20px;\n                }\n            }\n\n            .tab-pane {\n                overflow: auto;\n                width: 100%;\n\n                // height: calc(100vh - 200px) !important;\n                &::-webkit-scrollbar {\n                    display: none;\n                }\n            }\n\n            table {\n                font-size: $font_size_content;\n\n                thead {\n                    background-color: white;\n                    position: sticky;\n                    top: 0;\n\n                    tr.titles {\n                        border-style: hidden;\n                        background: #000000;\n                        color: white;\n\n                        th {\n                            position: sticky;\n                            top: 0;\n                            vertical-align: baseline;\n\n                            @media only screen and (max-width: 1760px) {\n                                font-size: 10px;\n                            }\n\n                            @media only screen and (max-width: 1280px) {\n                                font-size: 9px;\n                            }\n                        }\n\n                        .saleDate,\n                        .dateCustomerNeedsBy,\n                        .created,\n                        .dateReceivedInBackOffice,\n                        .dueDate,\n                        .addToMyList {\n                            cursor: pointer;\n                        }\n                    }\n\n                    tr.filters {\n                        th {\n                            gap: 10px;\n\n                            input {\n                                width: 100%;\n                                border: 1px solid #d2d2d2;\n                                border-radius: 3px;\n                            }\n\n                            &.saleDate {\n                                input {\n                                    width: 95px;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                tbody {\n                    tr {\n                        cursor: pointer;\n\n                        td {}\n                    }\n                }\n            }\n        }\n    }\n\n    .nav-tabs,\n    .nav-item.show {\n        .nav-link {\n            color: #E3B5BB !important;\n            border-color: #E3B5BB !important;\n\n            &.active {\n                background-color: #E3B5BB !important;\n                color: white !important;\n            }\n        }\n    }\n}\n\n.modal {\n    &.sale-edit-close-confirmation {\n        z-index: 2000;\n\n        .modal-dialog {\n            margin-top: 100px;\n            max-width: 50%;\n            width: 50%;\n        }\n    }\n\n    .nav-tabs,\n    .nav-item.show {\n        .nav-link {\n            color: #8ba6eb !important;\n\n            &.active {\n                background-color: black !important;\n                color: white !important;\n                border-color: black !important;\n            }\n\n            &.pending-changes {\n                color: red !important;\n            }\n        }\n    }\n\n    form {\n        .form-group {\n            margin-bottom: 1rem;\n        }\n\n        .select-box {\n            display: inline-block;\n            background-color: #F4F4F4;\n            padding: 5px 5px;\n            border-radius: 5px;\n            border-color: #F4F4F4;\n            margin-left: 10px;\n        }\n\n        .react-datepicker-wrapper {\n            .react-datepicker__input-container {\n                input {\n                    border: 1px solid #ced4da;\n                    border-radius: 0.25rem;\n                    padding: 0.375rem 0.75rem;\n                    width: 100%;\n                }\n            }\n        }\n\n        button[type=submit] {\n            background-color: black;\n            border-color: black;\n        }\n    }\n}\n\n#PostSaleSearch_component {\n    .infinite-scroll-component {\n        // height: 70vh !important;\n        margin-bottom: 20px;\n    }\n\n    .addToMyList {\n        display: none;\n    }\n}\n\n.center-element {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-novita-pink {\n    background-color: #E3B5BB !important;\n    color: white !important;\n    border-color: #E3B5BB !important;\n}\n\n.btn-novita-pink-outline {\n    color: #E3B5BB !important;\n    border-color: #E3B5BB !important;\n\n    &:hover {\n        background-color: #E3B5BB !important;\n        color: white !important;\n    }\n}\n\n.cost-not-ready {\n    background: #fcdddb;\n    padding-bottom: 15px;\n}\n\n.cost-not-ready-color {\n    color: red;\n}\n\n.workflow-cost-summary-container{\n    padding: 0 0px;\n    border-left: 1px solid gray;\n    border-right: 1px solid gray;\n    border-bottom: 1px solid gray;\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n    border-bottom-left-radius: 15px;\n    border-bottom-right-radius: 15px;\n    .workflow-cost-activities{\n        padding: 0 5px;\n        .workflow-cost-activity{\n            border-top-left-radius: 15px;\n            border-top-right-radius: 15px;\n            border-bottom-left-radius: 15px;\n            border-bottom-right-radius: 15px;\n            overflow: hidden;\n            margin-bottom: 15px;\n        }\n        h2.workflow-acivity-melees{\n            background-color: transparent !important;\n            border-bottom: 1px solid gray;\n            color: #000 !important;\n        }\n        h2.workflow-acivity-metal{\n            background-color: transparent !important;\n            border-bottom: 1px solid gray;\n            color: #000 !important;\n        }\n    }\n}\n\n#table_my_list {\n    height: 100%;\n}\n#SaleWorkflowEditCAD_request_component {\n    .btn-round {\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        font-size: 16px;\n        line-height: 15px;\n        border: 1px solid #E3B5BB;\n        background: #E3B5BB;\n        text-align: center;\n        color: white;\n        padding: 0px;\n        display: inline-block;\n    }\n\n    #cad_files_list_table {\n        td {\n            vertical-align: middle;\n        }\n        img {\n            width: 50px;\n            height: 50px;\n            object-fit: cover;\n        }\n    }\n    .rbt-input-multi.form-control {\n        min-height: 64px;\n    }\n}\n\n#SaleWorkflowEditCADList_component {\n    .workflowCadRequestTableList {\n        max-height: calc(-100px + 100vh);\n        overflow: auto;\n    }\n    table {\n        font-size: $font_size_content;\n\n        thead {\n            background-color: white;\n            tr.titles {\n                border-style: hidden;\n                background: #EEEEEE;\n\n                th.action {\n                    top: 0;\n                    vertical-align: baseline;\n                    background-color: inherit;\n                    max-width: 20%;\n                    width: 20%;\n                    text-align: left;\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                td.action {\n                    max-width: 20%;\n                    width: 20%;\n                    text-align: left;\n                    padding: 10px;\n                    vertical-align: middle;\n\n                    span {\n                        margin-bottom: 3px;\n                        display: block;\n                        color: $blue_link;\n                        &.mr-5 {\n                            margin-right: 10px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
